const select = 'id,title,description,reportGroupId,isPublic,isActive,powerBIReportID';

export default {
  paged: {
    select: 'id,isActive,order,type,title,powerBIReportID',
    searchSelect: ['title', 'powerBIReportID'],
    orderBy: 'order',
  },
  item: {
    select:
      'id,reportGroupId,title,description,tags,reportPlatform,type,order,powerBIReportId,powerBIDatasetId,powerBIDefaultReportSection,isMultipage,isReportDataFilterByUserEnabled,isReportDataFilterByPositionEnabled,isPublic,isActive,reportDataFilterUserTableName,reportDataFilterUserFieldName,reportDataFilterUserFieldNameInternal,reportDataFilterPositionTableName,reportDataFilterPositionFieldName,reportDataFilterPositionFieldNameInternal,permissionsFiltersLogicalOperator,isPublic,isAutoManaged,isReportDataFilterByUserCompanyEnabled,isReportDataFilterByUserEnvironmentEnabled',
    expand: {
      reportGroup: { select: 'name' },
    },
  },
  itemDetail: {
    select:
      'id,title,created,updated,description,tags,reportPlatform,type,order,powerBIReportId,powerBIDatasetId,powerBIDefaultReportSection,isMultipage,isReportDataFilterByUserEnabled,isReportDataFilterByPositionEnabled,isPublic,isActive,reportDataFilterUserTableName,reportDataFilterUserFieldName,reportDataFilterUserFieldNameInternal,reportDataFilterPositionTableName,reportDataFilterPositionFieldName,reportDataFilterPositionFieldNameInternal,permissionsFiltersLogicalOperator,isPublic,isAutoManaged,isReportDataFilterByUserCompanyEnabled,isReportDataFilterByUserEnvironmentEnabled',
    expand: {
      reportGroup: { select: 'name' },
      userCreator: { select: 'fullName' },
      userModifier: { select: 'fullName' },
    },
  },
  groups: {
    select: 'id,name',
    searchSelect: ['name'],
    notSelectSearch: 'reports',
    expand: {
      reports: { count: true },
    },
  },
  reports: {
    select,
    searchSelect: ['title', 'description', 'reportGroup/name'],
    notSelectSearch: 'reportGroup',
    expand: {
      reportGroup: { select: 'id,name' },
    },
    orderBy: 'order',
  },
  favorites: {
    select,
    searchSelect: ['title', 'description'],
    notSelectSearch: 'reportGroup,reports',
    expand: {
      reportGroup: { select: 'id,name' },
    },
    orderBy: 'order',
  },
  report: {
    select: `
        id,
        title,
        reportGroupId,
        powerBIReportId,
        powerBIDefaultReportSection,
        powerBIDatasetId,
        isMultipage,
        isReportDataFilterByUserEnabled,
        reportDataFilterUserTableName,
        reportDataFilterUserFieldName,
        reportDataFilterUserFieldNameInternal,
        isReportDataFilterByPositionEnabled,
        reportDataFilterPositionTableName,
        reportDataFilterPositionFieldName,
        reportDataFilterPositionFieldNameInternal,
        isReportDataFilterByUserCompanyEnabled,
        reportDataFilterUserCompanyTableName,
        reportDataFilterUserCompanyFieldName,
        reportDataFilterUserCompanyFieldNameInternal,
        isReportDataFilterByUserEnvironmentEnabled,
        reportDataFilterUserEnvironmentTableName,
        reportDataFilterUserEnvironmentFieldName,
        reportDataFilterUserEnvironmentFieldNameInternal`,
  },
};
